import { IPublicClientApplication, PublicClientApplication, BrowserCacheLocation, LogLevel } from "@azure/msal-browser";
import { AppConfigService } from "../services/app-config.service";

/**
 * Factory function to create an instance of MSAL (Microsoft Authentication Library).
 * @param appConfigService - The AppConfigService instance used to retrieve the MSAL configuration.
 * @returns An instance of IPublicClientApplication.
 */
export function MSALInstanceFactory(appConfigService: AppConfigService): IPublicClientApplication {
  const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;

  return new PublicClientApplication({
    auth: appConfigService.get().msal.auth,
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: isIE, // set to true for IE 11
    },
    system: {
      loggerOptions: {
          loggerCallback: (logLevel, message, containsPii) => {
              console.log(message);
          },
          logLevel: LogLevel.Error,
          piiLoggingEnabled: false
      }
  }
  });
}



